<div class="app-dialog">
  <header class="app-dialog__header">
    <div class="app-dialog__header-text">
      <h2>{{ 'badges.dialog.title' | translate }}</h2>
    </div>
    <button mat-icon-button type="button" (click)="cancel()" [attr.aria-label]="'cancel' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="app-dialog__body" [formGroup]="form">
    <mat-form-field appearance="fill" class="badges-dialog__full-width">
      <mat-label>
        {{ 'badges.dialog.label' | translate }}
      </mat-label>
      <input matInput formControlName="label" [errorStateMatcher]="errorStateMatcher" />
      <mat-error *ngIf="form.get('label')?.hasError('required')">
        {{ 'badges.dialog.labelRequired' | translate }}
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill" class="badges-dialog__full-width">
      <mat-label>
        {{ 'badges.dialog.description' | translate }}
      </mat-label>
      <textarea matInput formControlName="description"></textarea>
    </mat-form-field>

    <section class="app-dialog__section">
      <header class="app-dialog__section-head">
        <h3>{{ 'badges.dialog.imageHeader' | translate }}</h3>
      </header>
      <app-image-uploader
        [previewUrl]="previewUrl"
        [description]="'badges.dialog.chooseImage' | translate"
        (onFileChange)="onFileChange($event)"
        (onFileRemove)="removeImage()"
      ></app-image-uploader>
      <mat-error *ngIf="errorStateMatcher.submitAttempted && form.get('image')?.hasError('required')">
        {{ 'fileRequired' | translate }}
      </mat-error>
    </section>
  </div>

  <footer class="app-dialog__footer">
    <button mat-stroked-button type="button" (click)="cancel()">
      {{ 'badges.dialog.cancel' | translate }}
    </button>
    <button
      mat-raised-button
      color="primary"
      type="button"
      (click)="save()"
    >
      {{ 'badges.dialog.send' | translate }}
    </button>
  </footer>
</div>
